import { UserStatus } from '@@types/api.types';
import { Badge } from '@components/ui/badge';
import { CheckCircleIcon, ClockIcon, ShieldBanIcon } from 'lucide-react';

const statusVariants = {
  [UserStatus.APPROVED]: 'success',
  [UserStatus.BLOCKED]: 'blocked',
  [UserStatus.PENDING]: 'warning',
} as const satisfies Record<UserStatus, 'success' | 'blocked' | 'warning'>;

const statusLabels = {
  [UserStatus.APPROVED]: 'Approved',
  [UserStatus.BLOCKED]: 'Blocked',
  [UserStatus.PENDING]: 'Pending',
} satisfies Record<UserStatus, string>;

const statusIcons = {
  [UserStatus.APPROVED]: <CheckCircleIcon className="size-3" />,
  [UserStatus.BLOCKED]: <ShieldBanIcon className="size-3" />,
  [UserStatus.PENDING]: <ClockIcon className="size-3" />,
} satisfies Record<UserStatus, React.ReactNode>;

type UserStatusBadgeProps = {
  showIcon?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  status: UserStatus;
};

export const UserStatusBadge: React.FC<UserStatusBadgeProps> = (props) => {
  const { showIcon = true, size = 'sm', status } = props;

  const icon = statusIcons[status];
  const label = statusLabels[status];
  const variant = statusVariants[status];

  return (
    <Badge
      size={size}
      variant={variant}
    >
      {showIcon && icon}
      {label}
    </Badge>
  );
};
